import { z } from 'zod';

export const ResponseUnmaskStateSchema = z.object({
  responseId: z.number().int().positive(),
  isUnmasked: z.boolean(),
  eligible: z.boolean(),
  eligibleReason: z.string().nullable(),
  requestedAt: z.string().nullable(),
  approvedAt: z.string().nullable(),
  rejectedAt: z.string().nullable(),
  messageCount: z.number().int().nonnegative(),
  negotiationCount: z.number().int().nonnegative(),
  messageThreshold: z.number().int().positive(),
  negotiationThreshold: z.number().int().positive(),
  // [MCV-1755] Optional so a payload from before turn counting still parses.
  messageTurnCount: z.number().int().nonnegative().nullish(),
  privacyStatus: z.enum(['MASKED', 'ELIGIBLE', 'PENDING', 'REJECTED', 'UNMASKED']),
  requestToken: z
    .string()
    .regex(/^[a-f0-9]{64}$/)
    .nullable(),
  canRequest: z.boolean(),
  canApprove: z.boolean(),
  canReject: z.boolean(),
  canWithdraw: z.boolean(),
  // [MCV-1755] Optional so a payload from before the terms rollout still parses.
  // Which side the viewer is on. Either side may request disclosure; `canRequest` says whether this viewer can.
  viewerParty: z.enum(['RESPONDER', 'LISTING_OWNER']).nullish(),
  // Version of the Platform Participation Agreement both sides accept.
  termsVersion: z.string().nullish(),
  // For a pending request: false when the responder left it under the old rules
  // (it cannot be approved; disclosure has to be requested again).
  requesterIsListingOwner: z.boolean().nullish(),
});

export type ResponseUnmaskState = z.infer<typeof ResponseUnmaskStateSchema>;
